<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('TITLE.ADMIN.ANSWER.MANAGE') }}</i>
                    </dt>
                    <dd>
                        <div class="Select_wrap">
                            <ul class="txt_sel">
                                <li class="tit">{{ $t('TITLE.GLOBAL.ANSWERERS') }}</li>
                                <li data-input-type="select" class="sel">
                                    <fieldset class="serachbtn_wrap">
                                        <label class="serach-wrap">
                                            <input type="text" v-model="loginNm" class="text_input" disabled />
                                            <a href="javascript:" class="in_btn_search" @click="searchUserPop()">
                                                <i class="ico_input_serach"></i>
                                                <span class="sr_only"></span>
                                            </a>
                                        </label>
                                        <a href="javascript:" class="btn_white" @click="resetClick()">
                                            {{ $t('BUTTON.GLOBAL.RESET') }}
                                        </a>
                                    </fieldset>
                                </li>
                            </ul>
                        </div>

                        <div class="grid_wrap mt10">
                            <!-- Count -->
                            <div class="grid_total">
                                {{ $t('TITLE.TOTAL.COUNT') }} <em>{{ totalCount }}</em>
                            </div>
                            <div class="btn_wrap">
                                <a href="javascript:" class="btn_blue" @click="onSave()">
                                    {{ $t('BUTTON.GLOBAL.UPDATE') }}
                                </a>
                            </div>

                            <!-- Grid -->
                            <toast-grid
                                :gridId="gridId"
                                :columns="columns"
                                :data="gridData"
                                :options="options"
                                :ref="gridId"
                                :key="gridKey"
                                :isTotalCount="false"
                            />
                            <sdl-pagination
                                align="center"
                                :current-page="currentPage"
                                :total-rows="totalCount"
                                :per-page="nRecordsPerPage"
                                @change="onSearch"
                            />
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import axios from 'axios';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';

import ToastGrid from '~c/ToastGrid';
import searchUserPop from '~va/qnaManager/popup/searchUserPop';
import SDLPagination from '~~c/control/pagination/Pagination';

export default {
    name: 'answererChangePop',
    components: {
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
    },
    props: {
        searchDiv: '',
        listCheck: '',
        columns: '',
    },
    data() {
        return {
            pageName: 'answererChangePop',
            loginId: '',
            loginNo: '',
            loginNm: '',
            gridKey: 0,
            gridId: 'changeAnswererPopGrid',
            gridData: [],
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            totalCount: 0,
            currentPage: 1,
            options: {
                scrollX: true,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
                rowHeaders: ['checkbox'],
            },
        };
    },
    mounted() {
        this.onSearch(1);
    },
    methods: {
        async onSearch(v) {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/answererManage/answererSearch.skp`,
                    qs.stringify({
                        page: v,
                        searchInfo: 'set',
                        SEARCH_DIV: this.searchDiv,
                        answererIdList: this.listCheck,
                        searchAnswererNo: this.loginNo,
                    }),
                )
                .then(resp => {
                    this.gridData = resp.data.result.rowData;
                    this.currentPage = Number(resp.data.search.page);
                    this.totalCount = resp.data.search.totalRecords;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onSave() {
            let checkResult = this.buttonCheck('onSave');
            if (checkResult[0]) return SDLUtil.alert(checkResult[1]);

            let grid = this.$refs['changeAnswererPopGrid'].$refs['changeAnswererPopGrid'];
            let getData = grid.invoke('getData');
            let listCheck = [];
            for (const data of getData) {
                if (data._attributes.checked) {
                    listCheck.push(data.ANSWERER_ID);
                }
            }

            SDLUtil.confirm({
                msg: SDLUtil.getMsgProp('MESSAGE.DATA.MODIFY.CONFIRM'),
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/answererManage/answererUpdate.skp`,
                            qs.stringify({
                                SEARCH_DIV: this.searchDiv,
                                searchAnswererId: this.loginId,
                                dept_level_cd: this.getTabNo(this.searchDiv),
                                listCheck: this.listCheck,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            let msg = resp.data.msg;
                            SDLUtil.alert(msg);

                            if (msg.indexOf('successfully') > -1) {
                                return this.$emit('close');
                            }
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        searchUserPop() {
            SDLUtil.show(
                searchUserPop,
                {
                    rtnFunc: (arg1, arg2, arg3) => {
                        this.loginNo = arg1;
                        this.loginId = arg2;
                        this.loginNm = arg3;
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        resetClick() {
            this.loginNo = '';
            this.loginId = '';
            this.loginNm = '';
        },
        getTabNo(v) {
            let result = 0;
            if ('SUB' === v) result = 2;
            if ('RHQ' === v) result = 3;
            if ('GBM' === v) result = 4;
            return result;
        },
        buttonCheck(v) {
            let msg = '';
            let result = false;

            if (!this.systemAdminBoolean && !this.deptLevelCd === this.getTabNo(this.searchDiv)) {
                msg = 'Available only in the same level.';
                result = true;
            }

            let grid = this.$refs['changeAnswererPopGrid'].$refs['changeAnswererPopGrid'];
            let getData = grid.invoke('getData');
            let gridChecked = false;
            for (const data of getData) {
                if (data._attributes.checked) {
                    gridChecked = true;
                    if (data.ACTIVE === 'Y') {
                        msg = 'Please, not been deleted.';
                        result = true;
                    }
                }
            }

            if (!gridChecked) {
                msg = SDLUtil.getMsgProp('MESSAGE.DATA.CHECKITEM');
                result = true;
            }

            if ('onSave' === v && SDLUtil.isNull(this.loginNo)) {
                msg = 'Please, Enter the Answerer ID';
                result = true;
            }

            return [result, msg];
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/popup/answererChangePop.vue